import { render, staticRenderFns } from "./TeamControl.vue?vue&type=template&id=308e3405&scoped=true"
import script from "./TeamControl.vue?vue&type=script&lang=js"
export * from "./TeamControl.vue?vue&type=script&lang=js"
import style0 from "./TeamControl.vue?vue&type=style&index=0&id=308e3405&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308e3405",
  null
  
)

export default component.exports